import React, {useEffect, useState, useRef} from 'react';
import useIntersect from '../Hooks/useIntersect';

import AppFooter from '../Components/AppFooter';
import AppHeader from '../Components/AppHeader';

import Terms from '../Components/Terms';
import Meaning from '../Components/Meaning';
import Input from '../Components/Input';
import Toast from '../Components/Toast2';
import RadioInput from '../Components/RadioInput'

import {useHistory} from 'react-router-dom'



import Skeleton, { SkeletonTheme } from 'react-loading-skeleton'
import 'react-loading-skeleton/dist/skeleton.css'

import classes from './Dictionary.module.css'
import { checkStatus, parseJSON, parseStrapiResponse } from '../utils/strapiFetch';
import {
    lettersTrioFromFirstChar,
    styleForLetterFilterButton,
    FILTER_BUCKETS_BOOK,
} from '../utils/dictionaryLetterFilter';
import { isDictionaryNarrowLayout } from '../utils/dictionaryLayoutBreakpoints';

/** Misma URL de lista que Dictionary.js (text, definition, synonyms/localizations). */
function dictionaryTermsListUrl(locale, startsWith) {
    const base = `populate[synonyms][fields][0]=text&[fields][1]=locale&populate[synonyms][fields][1]=definition&populate[localizations][populate][synonyms][fields][0]=text&populate[localizations][populate][synonyms][fields][1]=definition&populate[localizations][populate][synonyms][fields][2]=locale&populate[localizations][fields][0]=text&populate[localizations][fields][1]=definition&populate[localizations][fields][2]=locale&fields[0]=text&locale=${locale}&fields[1]=definition&sort[0]=text%3Aasc`
    const root = `${process.env.REACT_APP_API_STRAPI_URL}api/terms?${base}`
    if (arguments.length >= 2) {
        return `${root}&filters[text][$startsWith]=${startsWith}`
    }
    return root
}

export default function BasicDictionary(props) {
    const [isLoadingTerms, setIsLoadingTerms] = useState(false) // 1
    const [isLoadingMeaning, setIsLoadingMeaning] = useState(false) // 2
    const [isLoadingMeaningTranslation, setIsLoadingMeaningTranslation] = useState(false) // 3
    const [isLoadingPredictedTerms, setIsLoadingPredictedTerms] = useState(false) // 4
    const [loader, setLoader] = useState(false) // 5
    const [page, setPage] = useState(1)  // 6
    const [termNotSelected, setTermNotSelected] = useState(true) // 7
    const [terms, setTerms] = useState([]) // 8
    const [termsMeta, setTermsMeta] = useState() // 9
    const [scrolledCount, setScrolledCount] = useState(2) // 10
    const [newFilterSearch, setNewFilterSearch] = useState(false) // 11
    const [reloaded, setReloaded] = useState(true) // 12
    const [currentSearch, setCurrentSearch] = useState('') // 13
    const currentSearchRef = useRef('')
    const predictiveFetchSeqRef = useRef(0)
    const termsListRequestIdRef = useRef(0)
    /** Cuando es true, el cambio de searchLanguage fue intencional (onChange1): el useEffect lo detecta y no resetea el idioma */
    const intentionalLangChangeRef = useRef(false)
    const beginTermsListRequest = () => {
        termsListRequestIdRef.current += 1
        return termsListRequestIdRef.current
    }
    const isActiveTermsListRequest = (id) => id === termsListRequestIdRef.current
    const [currentLetters, setCurrentLetters] = useState(['A','B','C']) // 14
    const [currentLetter, setCurrentLetter] = useState('') // 15
    const [displayedLetters, setDisplayedLetters] = useState(false) // 16
    const [displayedSearchBarOptions, setDisplayedSearchBarOptions] = useState(false) // 17
    const [meaning, setMeaning] = useState([]) // 18
    const [meaningHasSynonym, setMeaningHasSynonym] = useState(false) // 19
    const [meaningTranslation, setMeaningTranslation] = useState(false) // 20
    const [searched, setSearched] = useState('') // 21
    const [searchLanguage, setSearchLanguage] = useState('de') // 22
    const [displayedPredicted, setDisplayedPredicted] = useState(false) // 23
    const [predictedTerms, setPredictedTerms] = useState([]) // 24
    const [clipboard, setClipboard] = useState('') // 25
    const [toastVisible, setToastVisible] = useState(false) // 26
    const [clipboardTitle, setClipboardTitle] = useState('') // 27
    const [toastProperties, setToastProperties] = useState([]) // 28
    const [link, setLink] = useState([]) // 29
    const [mobile, setMobile] = useState(false) // 30
    const [searchBarDisplayed, setSearchBarDisplayed] = useState(false) // 31
    const [mobileMeaningStyle, setMobileMeaningStyle] = useState(false) // 32
    const [skeletonWidth, setSkeletonWidth] = useState() // 33
    const [selected, setSelected] = useState(['A','B','C']); // 35
    const [translatedLetter, setTranslatedLetter] = useState("");
    // const [comeFrom, setComeFrom] = useState()
    const [pageContent, setPageContent] = useState({})

    // Headers para Strapi (lista de términos). Si el usuario es tipo 1 o 2
    // se envía también el token de Golang y el id de usuario.
    let headers = { 'Content-Type': 'application/json' };
    const jwt = window.localStorage.getItem("jwt");
    let userId = window.localStorage.getItem("id");
    let account = window.localStorage.getItem("account");
    if (userId) {
        try {
            userId = JSON.parse(userId);
        } catch (e) {
            // si no es JSON, se usa tal cual
        }
    }
    if (jwt && userId && (account === '1' || account === '2' || account === 1 || account === 2)) {
        headers = {
            ...headers,
            Authorization: `Bearer ${jwt}`,
            'X-User-Id': userId,
        };
    }
    

    let termId = props.location.pathname.replace('/basicDictionary/','')
    window.localStorage.setItem("termId", termId);   

    const [ref, entry] = useIntersect({});

 
    // Working one
    useEffect(() => {
        if (window.location.pathname.startsWith('/basicDictionary/')) {
            document.getElementById("body").style.overflowY = "hidden"; 
            document.getElementById("body").style.position = 'fixed' 
        } else {
            document.getElementById("body").style.overflowY = "scroll";
            document.getElementById("body").style.position = 'relative'
        }
        
        if(termId == 0) {
            // Si el cambio vino de onChange1, ese handler ya carga la lista → salir
            if (intentionalLangChangeRef.current) {
                intentionalLangChangeRef.current = false
                return
            }
            let t = window.localStorage.getItem("jwt");
            if(t === null){
                window.location.href = '/'
            }
            setMobile(isDictionaryNarrowLayout())
            setIsLoadingTerms(true)
            setMeaning([])
            const reqId = beginTermsListRequest()
            fetch(`${process.env.REACT_APP_API_STRAPI_URL}api/terms?fields[0]=text&fields[1]=definition&locale=de&sort[0]=text:asc&populate[synonyms][fields][0]=text&populate[synonyms][fields][1]=definition&populate[synonyms][fields][2]=locale&populate[localizations][fields][0]=text&populate[localizations][fields][1]=definition&populate[localizations][fields][2]=locale&populate[localizations][populate][synonyms][fields][0]=text&populate[localizations][populate][synonyms][fields][1]=definition&populate[localizations][populate][synonyms][fields][2]=locale`, { 
                headers, method: 'GET' 
            })
            .then(parseStrapiResponse)
            .then(data => {
                if (!isActiveTermsListRequest(reqId)) return
                setTerms(data.data); setIsLoadingTerms(false); setIsLoadingMeaning(false); setTermsMeta(data.meta)
            })
            .catch(() => { setIsLoadingTerms(false); setIsLoadingMeaning(false) })
        }else{
            // Si el cambio vino de onChange1, ese handler ya carga meaning y lista → salir
            if (intentionalLangChangeRef.current) {
                intentionalLangChangeRef.current = false
                return
            }
            const reqId = beginTermsListRequest()
            let t = window.localStorage.getItem("jwt");
            if(t === null){
                window.location.href = '/'
            }
            setTermNotSelected(false)
            setMobile(isDictionaryNarrowLayout())
            if (isDictionaryNarrowLayout()) setMobileMeaningStyle(true)
            setIsLoadingTerms(true)
            setIsLoadingMeaning(true)
            setMeaning([])

            // Fetch A: info básica del término (text, locale) para navegación.
            // locale=all evita que Strapi filtre por el locale por defecto (de)
            // y devuelva vacío cuando el término está en otro idioma (ej. en).
            fetch(`${process.env.REACT_APP_API_STRAPI_URL}api/terms?filters[id][$eq]=${Number(termId)}&fields[0]=text&fields[1]=locale&locale=all`, {
                headers, method: 'GET'
            })
                .then(parseStrapiResponse)
                .then(data => {
                    if (!isActiveTermsListRequest(reqId)) return
                    const termInfo = data.data?.[0]?.attributes
                    if (!termInfo?.text) { setIsLoadingTerms(false); return }

                    const termText = termInfo.text
                    const termLocale = termInfo.locale ?? 'de'
                    const currentLetter = termText.slice(0, 1)

                    setSearchLanguage(termLocale)

                    let currentLetters
                    if (currentLetter === 'A' || currentLetter === 'À' || currentLetter==='B' || currentLetter==='C' || currentLetter === 'a' || currentLetter === 'à' || currentLetter==='b' || currentLetter==='c'){
                        currentLetters = ["A", "B", "C"]
                    } else if (currentLetter === 'D' || currentLetter==='E' || currentLetter==='F' || currentLetter === 'd' || currentLetter==='e' || currentLetter==='f') {
                        currentLetters = ["D", "E", "F"]
                    } else if (currentLetter === 'G' ||  currentLetter==='H' ||  currentLetter==='I' || currentLetter === 'g' ||  currentLetter==='h' ||  currentLetter==='i') {
                        currentLetters = ["G", "H", "I"]
                    } else if (currentLetter === 'J' ||  currentLetter==='K' ||  currentLetter==='L' || currentLetter === 'j' ||  currentLetter==='k' ||  currentLetter==='l') {
                        currentLetters = ["J", "K", "L"]
                    } else if (currentLetter === 'M' ||  currentLetter==='N' ||  currentLetter==='O' || currentLetter === 'm' ||  currentLetter==='n' ||  currentLetter==='o' ) {
                        currentLetters = ["M", "N", "O"]
                    } else if (currentLetter === 'P' ||  currentLetter==='Q' ||  currentLetter==='R' || currentLetter === 'p' ||  currentLetter==='q' ||  currentLetter==='r') {
                        currentLetters = ["P", "Q", "R"]
                    } else if (currentLetter === 'S' ||  currentLetter==='T' ||  currentLetter==='U' || currentLetter === 's' ||  currentLetter==='t' ||  currentLetter==='u' || currentLetter==='Ü' || currentLetter==='ü') {
                        currentLetters = ["S", "T", "U"]
                    } else if (currentLetter === 'V' ||  currentLetter==='W' ||  currentLetter==='X' || currentLetter === 'v' ||  currentLetter==='w' ||  currentLetter==='x') {
                        currentLetters = ["V", "W", "X"]
                    } else if (currentLetter === 'Y' ||  currentLetter==='Z' || currentLetter === 'y' ||  currentLetter==='z') {
                        currentLetters = ["Y", "Z"]
                    } else {
                        currentLetters = ["A", "B", "C"]
                    }

                    setCurrentLetters(currentLetters)
                    setSelected(currentLetters)
                    setCurrentLetter(currentLetter)
                    setCurrentSearch(termText.slice(0, 4))

                    // Lista de términos filtrada por prefijo (misma query que Dictionary.js)
                    fetch(dictionaryTermsListUrl(termLocale, termText.slice(0, 4)), {
                        headers, method: 'GET'
                    })
                        .then(parseStrapiResponse)
                        .then(d => {
                            if (!isActiveTermsListRequest(reqId)) return
                            setTerms(d.data); setIsLoadingTerms(false); setTermsMeta(d.meta)
                        })
                        .catch(() => { setIsLoadingTerms(false) })
                })
                .catch(() => { setIsLoadingTerms(false) })

            // Fetch B: datos completos del término para el panel de significado
            fetch(`${process.env.REACT_APP_API_STRAPI_URL}api/terms/${Number(termId)}?populate=*`, {
                headers, method: 'GET'
            })
                .then(checkStatus)
                .then(parseJSON)
                .then(data => {
                    if (!isActiveTermsListRequest(reqId)) return
                    if (!data.data?.attributes) { setIsLoadingMeaning(false); return }
                    setMeaning({...data.data.attributes})
                    setIsLoadingMeaning(false)
                })
                .catch(() => { setIsLoadingMeaning(false) })
            
            }
        
    }, [translatedLetter])

    useEffect(() => {
        currentSearchRef.current = currentSearch
    }, [currentSearch])

    useEffect(() => {
        const onResize = () => {
            const narrow = isDictionaryNarrowLayout()
            setMobile(narrow)
            if (!narrow) setMobileMeaningStyle(false)
        }
        onResize()
        window.addEventListener('resize', onResize)
        return () => window.removeEventListener('resize', onResize)
    }, [])

    useEffect(() => {
        setToastProperties({
            description: `${clipboardTitle.toUpperCase()}`,
            borderColor: '#0A9DE4',
            icon: 'icon-success'
        })
    }, [clipboardTitle])

    // Fallback: when Fetch B (individual term endpoint) is blocked or fails for non-free terms,
    // populate a partial meaning from the terms list so title, subtitle and synonyms are visible.
    useEffect(() => {
        if (
            !isLoadingMeaning &&
            !isLoadingTerms &&
            !(meaning?.text) &&
            termId &&
            String(termId) !== '0' &&
            Array.isArray(terms) &&
            terms.length > 0
        ) {
            const termFromList = terms.find(t => String(t?.id) === String(termId))
            if (termFromList?.attributes?.text) {
                setMeaning({
                    text: termFromList.attributes.text,
                    synonyms: termFromList.attributes.synonyms,
                    free: termFromList.attributes.free,
                    locale: termFromList.attributes.locale,
                })
            }
        }
    }, [isLoadingMeaning, isLoadingTerms, termId, terms, meaning])


    const getMeaning = (id) => {
        setIsLoadingMeaning(true)
        setMeaning([])

        // id = props.match.params.id;
        const requestOptions = {
            method: 'GET',
            headers,
        }

        fetch(`${process.env.REACT_APP_API_STRAPI_URL}api/terms/`+id+`?populate=*`, requestOptions)
        .then(checkStatus)
        .then(parseJSON)
        .then((json) => {
            if (!json.data?.attributes) { setIsLoadingMeaning(false); return }
            setIsLoadingMeaning(false)
            setMeaningTranslation(false)
           
            if(id !== '0') {
                const attrs = json.data.attributes || {}
                const locale = attrs.locale ?? json.data?.locale ?? 'de'
                setMeaning({ ...attrs, locale })
            } else if(translatedLetter === "" ) {
                const attrs = json.data.attributes || {}
                const locale = attrs.locale ?? json.data?.locale ?? 'de'
                setMeaning({ ...attrs, locale })
            }
        })
        .catch(() => { setIsLoadingMeaning(false) })
        
    }

    const getTermsWithLanguage = (lan) => {
        setIsLoadingTerms(true)
        const reqId = beginTermsListRequest()
        // fetch(`${process.env.REACT_APP_API_STRAPI_URL}/api/terms?populate=*&locale=${lan}&filters[text][$startsWith]=${currentLetter}&sort[0]=text%3Aasc` , { 
        //     headers, method: 'GET' 
        // })
        fetch(dictionaryTermsListUrl(lan, currentLetter), { 
            headers, method: 'GET' 
        })
          .then(checkStatus)
          .then(parseJSON)
          .then(( data ) => {
              if (!isActiveTermsListRequest(reqId)) return
              setTerms(data.data); setIsLoadingTerms(false); setTermsMeta(data.meta)
          })
          .catch(() => { setIsLoadingTerms(false) })
        
    }

    const getTermsWithLetter = (letter) => {
        setCurrentSearch(letter)
        currentSearchRef.current = letter
        setIsLoadingTerms(true)
        const reqId = beginTermsListRequest()
        const requestOptions = {
            method: 'GET',
            headers,
        }

        // fetch(`${process.env.REACT_APP_API_STRAPI_URL}/api/terms?populate=*&locale=${searchLanguage}&filters[text][$startsWith]=${letter}&sort[0]=text%3Aasc`, requestOptions)
        fetch(dictionaryTermsListUrl(searchLanguage, letter), requestOptions)
        .then(checkStatus)
        .then(parseJSON)
        .then((json) => {
            if (!isActiveTermsListRequest(reqId)) return
            setTermsMeta(json.meta)
            setTerms(json.data)
            setIsLoadingTerms(false)
            const trimmedQ = typeof letter === 'string' ? letter.trim() : ''
            const anchor =
                trimmedQ.length > 0
                    ? trimmedQ.charAt(0)
                    : json.data?.[0]?.attributes?.text?.charAt(0) ?? ''
            const trio = lettersTrioFromFirstChar(anchor)
            setCurrentLetters(trio)
            setSelected(trio)
            if(json.data.length > 0 && searched !== '') {
                setCurrentLetter(json.data[0].attributes.text.charAt(0).toUpperCase())
            } 
            else if(json.data.length > 0 && searched === '') {
                setCurrentLetter(json.data[0].attributes.text.charAt(0).toUpperCase())
            }
            else if (json.data.length === 0) {
                setCurrentLetter('')
            }
        })
        .catch(() => { setIsLoadingTerms(false) })
    }

    const getAllTerms = (lang) => {
        setIsLoadingTerms(true)
        setCurrentLetter("")
        const reqId = beginTermsListRequest()
        fetch(dictionaryTermsListUrl(lang), { 
                headers, method: 'GET' 
        })
        .then(parseStrapiResponse)
        .then(data => {
            if (!isActiveTermsListRequest(reqId)) return
            setTerms(data.data); setIsLoadingTerms(false); setIsLoadingMeaning(false); setTermsMeta(data.meta)
        })
        .catch(() => { setIsLoadingTerms(false); setIsLoadingMeaning(false) })
    }



    const getMeaningTraducion = (meaningTraductionId) => {
        // Fallback inmediato desde la lista ya cargada:
        // los localizations de currentTermFromList incluyen synonyms, text y locale
        // aunque populate=* sea 403 (cuentas básicas / términos no free).
        const allLocs = [
            ...(currentTermFromList?.attributes?.localizations?.data ?? []),
        ]
        const locFromList = allLocs.find(l => String(l?.id) === String(meaningTraductionId))
        if (locFromList?.attributes) {
            setMeaningTranslation({
                text: locFromList.attributes.text,
                locale: locFromList.attributes.locale,
                synonyms: locFromList.attributes.synonyms,
                free: locFromList.attributes.free,
            })
        }

        // Intenta populate=* para obtener datos completos (definición, etc.)
        // Puede ser 403 para términos no free — el catch solo pone isLoading a false.
        const requestOptions = {
            method: 'GET',
            headers,
        }

        fetch(`${process.env.REACT_APP_API_STRAPI_URL}api/terms/${meaningTraductionId}?populate=*`, requestOptions)
        .then(checkStatus)
        .then(parseJSON)
        .then((json) => {
            if (!json.data?.attributes) { setIsLoadingMeaningTranslation(false); return }
            setMeaningTranslation(json.data.attributes)
            setIsLoadingMeaningTranslation(false)
        })
        .catch(() => { setIsLoadingMeaningTranslation(false) })
    }

    const getTermsWithPredictive = (lan, search) => {
        setIsLoadingPredictedTerms(true)
        const seq = ++predictiveFetchSeqRef.current
        fetch(`${process.env.REACT_APP_API_STRAPI_URL}api/terms?populate=[terms]&[fields][1]=free&[fields][2]=text&locale=${lan}&filters[text][$startsWith]=${search}&pagination[limit]=5&sort[0]=text%3Aasc`, {
            headers, method: 'GET'
        })
            .then(parseStrapiResponse)
            .then(( data ) => {
                if (seq !== predictiveFetchSeqRef.current) return
                setPredictedTerms(data.data)
                setDisplayedPredicted(true)
                setIsLoadingPredictedTerms(false)
            })
            .catch(() => {})
            .finally(() => setIsLoadingPredictedTerms(false))
    }

    const sendConsultedTermMetric = (id) => {
        // setIsLoadingTerms(true)
        // setCurrentLetter("")
        fetch(`${process.env.REACT_APP_API_GOLANG_URL}/v1/mterm/${id}`, {method: 'POST' })
            // .then(data => data.json())
            // .then(data => {setTerms(data.data); setIsLoadingTerms(false); setIsLoadingMeaning(false); setTermsMeta(data.meta)})
    }

    // currentTermFromList: desde la lista (garantiza locale+text en localizations)
    const currentTermFromList = terms?.find(t => String(t?.id) === String(termId))

    // listOfCurrentTraductions: prioridad 1 = terms list (locale garantizado),
    // fallback = meaning.localizations (populate=*, puede faltar locale en Strapi v4)
    const wantOrderDict = ['fr', 'it', 'en']
    let listOfCurrentTraductions = []
    const listLocsForTraductions = currentTermFromList?.attributes?.localizations?.data ?? []
    if (Array.isArray(listLocsForTraductions) && listLocsForTraductions.length > 0) {
        wantOrderDict.forEach((locale) => {
            const found = listLocsForTraductions.find((l) => {
                const ll = (l?.attributes?.locale ?? l?.locale)?.toLowerCase?.()
                return ll === locale
            })
            if (found) {
                const lid = found?.id ?? found?.attributes?.id
                if (lid != null) listOfCurrentTraductions.push(lid, locale)
            }
        })
    } else {
        // Fallback: meaning.localizations de populate=*
        let traductions = {...meaning.localizations}.data
        let listOfTradcutions = []
        Object.values({...traductions}).map((l) => {
            listOfTradcutions.push(l.id, l.attributes.locale)
            listOfCurrentTraductions = listOfTradcutions.slice(0).slice(-6)
        })
    }
    const subtitleByLang = (() => {
        const result = {}
        // DE: texto base del término
        if (meaning?.text) result.de = meaning.text
        // FR/IT/EN desde la lista de términos (garantiza text + locale)
        const listLocs = currentTermFromList?.attributes?.localizations?.data ?? []
        ;(Array.isArray(listLocs) ? listLocs : []).forEach((l) => {
            const locale = (l?.attributes?.locale ?? l?.locale)?.toLowerCase?.()
            const text = l?.attributes?.text ?? l?.text
            if (locale && text) result[locale] = text
        })
        // Fallback: localizations de meaning (populate=*)
        if (Object.keys(result).length <= 1) {
            const locs = meaning?.localizations?.data ?? (Array.isArray(meaning?.localizations) ? meaning.localizations : [])
            ;(Array.isArray(locs) ? locs : []).forEach((l) => {
                const locale = (l?.attributes?.locale ?? l?.locale)?.toLowerCase?.()
                const text = l?.attributes?.text ?? l?.text
                if (locale && text) result[locale] = text
            })
        }
        // Siempre sobreescribir con la traducción ya cargada (más precisa)
        if (meaningTranslation?.locale && meaningTranslation?.text) {
            result[meaningTranslation.locale.toLowerCase()] = meaningTranslation.text
        }
        return result
    })()

    const baseTermId = (() => {
        const locs = currentTermFromList?.attributes?.localizations?.data ?? meaning?.localizations?.data ?? []
        const deLoc = Array.isArray(locs) && locs.find((l) => ((l?.attributes?.locale ?? l?.locale) || '').toLowerCase() === 'de')
        return deLoc ? (deLoc?.id ?? deLoc?.attributes?.id) : termId
    })()

    const changeDisplayedLetters = () => {
        setDisplayedLetters(!displayedLetters)
    }


    function useOutsideAlerter(ref) {
        useEffect(() => {
         
           // Alert if clicked on outside of element
         
          function handleClickOutside(event) {
            if (ref.current && !ref.current.contains(event.target) ) {
                setDisplayedLetters(false)
                // setDisplayedSearchBarOptions(false)

            }
          
          }
          // Bind the event listener
          document.addEventListener("mousedown", handleClickOutside);
          return () => {
            // Unbind the event listener on clean up
            document.removeEventListener("mousedown", handleClickOutside);
          };
        }, [ref]);
    }

    function useOutsideAlerter2(ref2) {
        useEffect(() => {
         
           // Alert if clicked on outside of element
         
          function handleClickOutside(event) {
            if (ref2.current && !ref2.current.contains(event.target) ) {
                // setDisplayedLetters(false)
                setDisplayedSearchBarOptions(false)

            }
          
          }
          // Bind the event listener
          document.addEventListener("mousedown", handleClickOutside);
          return () => {
            // Unbind the event listener on clean up
            document.removeEventListener("mousedown", handleClickOutside);
          };
        }, [ref2]);
    }

    const wrapperRef= useRef(null);
    
    useOutsideAlerter(wrapperRef);

    const wrapperRef2= useRef(null);

    useOutsideAlerter2(wrapperRef2);

    const FilterByLetter = ({currentLetters}) => {
        const letters = Array.isArray(currentLetters) ? currentLetters : ['A', 'B', 'C']
        const s0 = styleForLetterFilterButton({
            currentSearch,
            currentLetter,
            btnLetter: letters[0],
            trioLetters: letters,
            columnIdx: 0,
            buckets: FILTER_BUCKETS_BOOK,
            bookDialect: true,
        })
        const s1 = styleForLetterFilterButton({
            currentSearch,
            currentLetter,
            btnLetter: letters[1],
            trioLetters: letters,
            columnIdx: 1,
            buckets: FILTER_BUCKETS_BOOK,
            bookDialect: true,
        })
        const s2 = styleForLetterFilterButton({
            currentSearch,
            currentLetter,
            btnLetter: letters[2],
            trioLetters: letters,
            columnIdx: 2,
            buckets: FILTER_BUCKETS_BOOK,
            bookDialect: true,
        })

        return (
            <>
            <div style={{fontFamily: 'Work Sans'}}>
                <div>
                    <div className={classes.filterByLetterMain}>
                        <div className={classes.moreLetters}>
                            <span>{letters.slice(0, 3)}</span>
                            <button onClick={() => changeDisplayedLetters()} className='none'><i className='icon ms-1 icon-more'></i></button>
                        </div>
                        <div className={classes.FilterByLetterButtonsContainer}>
                            <button 
                                style={s0} 
                                className={classes.filterButton}
                                id={letters[0]} 
                                onClick={() => {
                                    getTermsWithLetter(letters[0]); 
                                    setCurrentSearch(letters[0]);
                                    setScrolledCount(2);
                                    setSearched('')
                                    setReloaded(false)
                                    setTermNotSelected(true)
                                    setMeaning([])
                                    props.history.push({
                                        pathname: "/basicDictionary/0",
                                    })
                                }}
                            >
                                {letters[0]}
                            </button>
                            <button 
                                style={s1} 
                                className={classes.filterButton}
                                id={letters[1]} 
                                onClick={() => {
                                    getTermsWithLetter(letters[1]); 
                                    setCurrentSearch(letters[1]);
                                    setScrolledCount(2);
                                    setSearched('')
                                    setReloaded(false)
                                    setTermNotSelected(true)
                                    setMeaning([])
                                    props.history.push({
                                        pathname: "/basicDictionary/0",
                                    })
                                }}
                            >
                                {letters[1]}
                            </button>
                            <button 
                                style={s2} 
                                className={classes.filterButton}
                                id={letters[2]} 
                                onClick={() => {
                                    getTermsWithLetter(letters[2]); 
                                    setCurrentSearch(letters[2]);
                                    setScrolledCount(2)
                                    setSearched('')
                                    setReloaded(false)
                                    setTermNotSelected(true)
                                    setMeaning([])
                                    props.history.push({
                                        pathname: "/basicDictionary/0",
                                    })
                                }}
                            >
                                {letters[2]}
                            </button>
                            <button 
                                style={{
                                    backgroundColor: currentSearch === "" && currentLetter === "" ? 'rgba(243, 191, 76, .55)' : 'none',
                                    fontSize:'small',
                                    textTransform:'none'
                                }}  
                                className={classes.filterButton}
                                id={"allTerms"} 
                                onClick={() => {
                                    getAllTerms(searchLanguage)
                                    setCurrentSearch("");
                                    setScrolledCount(2);
                                    setSearched('')
                                    setReloaded(false)
                                    setTermNotSelected(true)
                                    setMeaning([])
                                    setTranslatedLetter("")
                                    setCurrentLetters(['A','B','C', 'À'])
                                    props.history.push({
                                        pathname: "/basicDictionary/0",
                                    })
                                }}
                            >
                                {/* {
                                    props.language === "de"
                                    ?
                                    <>Alle Begriffe</>
                                    :
                                    <>All terms</>
                                } */}
                                {pageContent.search_all_button}
                            </button>
                        </div>
                        
                    </div>
                    {displayedLetters
                        ?
                        <span className={classes.radioSelectLettersContainer} ref={wrapperRef} >
                            <div className={classes.radioSelectLettersTitle} >{pageContent.radio_button_filter}</div>
                            <div className={classes.radioSelectLetters} >
                                <div className={classes.radioSelectLettersColumn}>
                                    <div>
                                        <RadioInput 
                                            value={['A','B','C', 'À']}
                                            selected={selected}
                                            text="ABC"
                                            onChange={(val) => {
                                                setSearched('')
                                                setSelected(val); 
                                                setCurrentLetters(val); 
                                                setCurrentLetter(val[0]); 
                                                getTermsWithLetter(val[0]); 
                                                setDisplayedLetters(false);
                                                setCurrentSearch(val[0]);
                                                setScrolledCount(2);
                                                props.history.push({
                                                    pathname: "/basicDictionary/0",
                                                })
                                            }}
                                        />
                                    </div>
                                    <div>
                                        <RadioInput 
                                            value={['D','E','F']}
                                            selected={selected}
                                            text="DEF"
                                            onChange={(val) => {
                                                setSearched('')
                                                setSelected(val); 
                                                setCurrentLetters(val); 
                                                setCurrentLetter(val[0]); 
                                                getTermsWithLetter(val[0]); 
                                                setDisplayedLetters(false);
                                                setCurrentSearch(val[0]);
                                                setScrolledCount(2)
                                                props.history.push({
                                                    pathname: "/basicDictionary/0",
                                                })
                                            }}
                                        />
                                    </div>
                                    <div>
                                        <RadioInput 
                                            value={['G','H','I']}
                                            selected={selected}
                                            text="GHI"
                                            onChange={(val) => {
                                                setSearched('')
                                                setSelected(val); 
                                                setCurrentLetters(val); 
                                                setCurrentLetter(val[0]); 
                                                getTermsWithLetter(val[0]); 
                                                setDisplayedLetters(false);
                                                setCurrentSearch(val[0]);
                                                setScrolledCount(2)
                                                props.history.push({
                                                    pathname: "/basicDictionary/0",
                                                })
                                            }}
                                        />
                                    </div>
                                    <div>
                                        <RadioInput 
                                            value={['J','K','L']}
                                            selected={selected}
                                            text="JKL"
                                            onChange={(val) => {
                                                setSearched('')
                                                setSelected(val); 
                                                setCurrentLetters(val); 
                                                setCurrentLetter(val[0]); 
                                                getTermsWithLetter(val[0]);  
                                                setDisplayedLetters(false);
                                                setCurrentSearch(val[0]);
                                                setScrolledCount(2)
                                                props.history.push({
                                                    pathname: "/basicDictionary/0",
                                                })
                                            }}
                                        />
                                    </div>
                                    <div>
                                        <RadioInput 
                                            value={['M','N','O']}
                                            selected={selected}
                                            text="MNO"
                                            onChange={(val) => {
                                                setSearched('')
                                                setSelected(val); 
                                                setCurrentLetters(val); 
                                                setCurrentLetter(val[0]); 
                                                getTermsWithLetter(val[0]); 
                                                setDisplayedLetters(false);
                                                setCurrentSearch(val[0]);
                                                setScrolledCount(2)
                                                props.history.push({
                                                    pathname: "/basicDictionary/0",
                                                })
                                            }}
                                        />
                                    </div>
                                </div>
                                <div className={classes.radioSelectLettersColumn}>
                                    <div>
                                        <RadioInput 
                                            value={['P','Q','R']}
                                            selected={selected}
                                            text="PQR"
                                            onChange={(val) => {
                                                setSearched('')
                                                setSelected(val); 
                                                setCurrentLetters(val); 
                                                setCurrentLetter(val[0]); 
                                                getTermsWithLetter(val[0]);  
                                                setDisplayedLetters(false);
                                                setCurrentSearch(val[0]);
                                                setScrolledCount(2)
                                                props.history.push({
                                                    pathname: "/basicDictionary/0",
                                                })
                                            }}
                                        />
                                    </div>
                                    <div>
                                        <RadioInput 
                                            value={['S','T','U','Ü']}
                                            selected={selected}
                                            text="STU"
                                            onChange={(val) => {
                                                setSearched('')
                                                setSelected(val); 
                                                setCurrentLetters(val); 
                                                setCurrentLetter(val[0]); 
                                                getTermsWithLetter(val[0]);  
                                                setDisplayedLetters(false);
                                                setCurrentSearch(val[0]);
                                                setScrolledCount(2)
                                                props.history.push({
                                                    pathname: "/basicDictionary/0",
                                                })
                                            }}
                                        />
                                    </div>
                                    <div>
                                        <RadioInput 
                                            value={['V','W','X']}
                                            selected={selected}
                                            text="VWX"
                                            onChange={(val) => {
                                                setSearched('')
                                                setSelected(val); 
                                                setCurrentLetters(val); 
                                                setCurrentLetter(val[0]); 
                                                getTermsWithLetter(val[0]); 
                                                setDisplayedLetters(false);
                                                setCurrentSearch(val[0]);
                                                setScrolledCount(2)
                                                props.history.push({
                                                    pathname: "/basicDictionary/0",
                                                })
                                            }}
                                        />
                                    </div>
                                    <div>
                                        <RadioInput 
                                            value={['Y','Z']}
                                            selected={selected}
                                            text="YZ"
                                            onChange={(val) => {
                                                setSearched('')
                                                setSelected(val); 
                                                setCurrentLetters(val); 
                                                setCurrentLetter(val[0]); 
                                                getTermsWithLetter(val[0]);  
                                                setDisplayedLetters(false);
                                                setCurrentSearch(val[0]);
                                                setScrolledCount(2)
                                                props.history.push({
                                                    pathname: "/basicDictionary/0",
                                                })
                                            }}
                                        />
                                    </div>
                                </div>
                            </div>
                        </span>
                        :
                        null                   
                    }
                </div>
            </div>
            </>
        )
    }

    let history = useHistory()

    const handleShareButton = (ShareId, ShareTitle) => {
        // Check if navigator.share is supported by the browser
        if (navigator.share) {
          console.log("Congrats! Your browser supports Web Share API");
          navigator
            .share({
              url: `https://accounting-a-z.ch/dictionary/${ShareId}`,
              title: '*Accounting dictionary* - Register! More than 1,000 terms',
              text: `Accounting dictionary - Register! More than 1,000 terms \n ${ShareTitle}`,
            })
            .then(() => {
              console.log("Sharing successfull");
            })
            .catch(() => {
              console.log("Sharing failed");
            });
        } else {
          console.log("Sorry! Your browser does not support Web Share API");
        }
    };

    
    return(
        <div className={classes.container}>
            {
                window.onbeforeunload = function () {
                    fetch(`${process.env.REACT_APP_API_GOLANG_URL}/v1/removeactiveuser/${window.localStorage.getItem("id")}`, { 
                        method: 'GET', keepalive: true
                    })
                    fetch(`${process.env.REACT_APP_API_GOLANG_URL}/v1/timesave/${(entry.time/1000)/60}`, { 
                        method: 'GET', keepalive: true
                    })
                }
            }
            {/* <span style={{position:'absolute', top:'12vh'}}>{window.localStorage.getItem("time")}</span> */}
            {/* <span style={{position:'absolute', top:'10vh', color:'blue'}}>{(entry.time/1000)/60}</span> */}
            <div ref={ref}  style={{display:'none'}}>none</div>
            <Toast
                toastList={toastProperties}
                position="top-right" 
                visible={toastVisible}
                language={props.language}
                pageContent={pageContent}

            />
            <AppHeader 
                setDictionaryContent={(val) => setPageContent(val)}
                appLanguage={props.language}
                // setComeFrom={(val) => {setComeFrom("basicDictionary")}}
                // ComeFrom ={comeFrom}
                basicDictionary={true}
                currentTerm = {meaning.text}
                // setCurrentTerm={(val) => console.log(val)}
                onSelectPreviosSearch={(val) => setDisplayedSearchBarOptions(val)}
                searchBarDisplayed={searchBarDisplayed}
                setSearchBarDisplayed={(val) => setSearchBarDisplayed(val)}
                currentPathName={props.location.pathname}
                currentId={props.location.pathname.replace('/basicDictionary/','')}
                onClick3={(letters) => getTermsWithLetter(letters) }
                onClick5={(search) => setSearched(search)}
                onFocus1={() => setDisplayedSearchBarOptions(true)}
                // onBlur1={() => setDisplayedSearchBarOptions(false)}
                setReloaded={(val) => setReloaded(val)}
                isLoadingPredictedTerms={isLoadingPredictedTerms}
                getTermsWithPredictive={(partial) => {
                    setDisplayedSearchBarOptions(true)
                    if(partial ===""){
                        setDisplayedPredicted(false)
                        setPredictedTerms([])
                    } else {
                        // console.log(partial===currentSearch)
                        getTermsWithPredictive(searchLanguage ,partial);
                        // console.log(partial)
                    }
                    
                }}
                setCurrentSearch={(val) => {
                    currentSearchRef.current = val
                    setCurrentSearch(val)
                    if(val === "") {
                        setPredictedTerms([])
                    }
                }}
                displayedPredicted={displayedPredicted}
                predictedTerms = {predictedTerms}
                displayedSearchBarOptions={displayedSearchBarOptions}
                sendConsultedTermMetric={(id) => sendConsultedTermMetric(id)}
                ref2={wrapperRef2}
                options={displayedSearchBarOptions}
                search={props.match.path}
                onChange1={(lan) => {
                    setIsLoadingTerms(true)
                    let currentId
                    if (lan === 'de') {
                        const locs = currentTermFromList?.attributes?.localizations?.data ?? meaning?.localizations?.data ?? []
                        const deLoc = Array.isArray(locs) && locs.find((l) => ((l?.attributes?.locale ?? l?.locale) || '').toLowerCase() === 'de')
                        currentId = deLoc ? (deLoc?.id ?? deLoc?.attributes?.id) : props.match.params.id
                    } else {
                        const translationId = listOfCurrentTraductions[listOfCurrentTraductions.indexOf(lan) - 1]
                        currentId = translationId !== undefined ? translationId : props.match.params.id
                    }
                    if(currentId !== "0" && currentId != null){
                        getMeaning(currentId)
                        intentionalLangChangeRef.current = true
                        setSearchLanguage(lan);
                        // Use the list endpoint (more permissive than findOne for non-free terms)
                        // to get term text, then load the terms list with $startsWith
                        fetch(`${process.env.REACT_APP_API_STRAPI_URL}api/terms?filters[id][$eq]=${Number(currentId)}&fields[0]=text&locale=all`, { headers, method: 'GET'})
                            .then(parseStrapiResponse)
                            .then(json => {
                                const termText = json.data?.[0]?.attributes?.text
                                if (!termText) { setIsLoadingTerms(false); return }
                                const prefix = termText.slice(0, 4)
                                const reqIdList = beginTermsListRequest()
                                fetch(dictionaryTermsListUrl(lan, prefix), { headers, method: 'GET' })
                                    .then(parseStrapiResponse)
                                    .then(d => {
                                        if (!isActiveTermsListRequest(reqIdList)) return
                                        setTerms(d.data); setIsLoadingTerms(false); setTermsMeta(d.meta)
                                        setCurrentSearch(prefix)
                                    })
                                    .catch(() => { setIsLoadingTerms(false) })
                                setTimeout(() => {
                                    if (document.getElementById(`${termText}`) ===  null){
                                        setTimeout(() => {
                                            document.getElementById(`${termText}`)?.parentElement?.parentElement?.parentElement?.scrollIntoView({behavior: "smooth"})
                                        }, 3000);
                                        
                                    } else {
                                        document.getElementById(`${termText}`)?.parentElement?.parentElement?.parentElement?.scrollIntoView({behavior: "smooth"})
                                    }
                                }, 1500);
                            })
                            .catch(() => { setIsLoadingTerms(false) })
                    }else {
                        intentionalLangChangeRef.current = true
                        setSearchLanguage(lan);
                        const reqId = beginTermsListRequest()
                        fetch(dictionaryTermsListUrl(lan), { 
                                headers, method: 'GET' 
                        })
                        .then(parseStrapiResponse)
                        .then(data => {
                            if (!isActiveTermsListRequest(reqId)) return
                            setTerms(data.data); setIsLoadingTerms(false); setIsLoadingMeaning(false); setTermsMeta(data.meta)
                        })
                        .catch(() => { setIsLoadingTerms(false) })
                    }
                        history.push(`/basicDictionary/${currentId}`)
                   
                }}
                lastVisited = {localStorage.getItem('recentSearch') !== null ? localStorage.getItem('recentSearch').split(/\,\/|\,(?=[a-zA-Z])/g).concat(['', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '']): ['', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '']}
                getMeaning={(id) => getMeaning(id)}
                // setMobileMeaningStyle = {(val) => setMobileMeaningStyle(val)}
                // mobileMeaningStyle = {mobileMeaningStyle}
                mobile = {mobile}
                setLink = {(val) => {setLink([...[val], ...link]); localStorage.setItem('recentSearch',[...[val], ...link])}}
                language={searchLanguage}
                setTermVisible={(val) => {
                    setSearched(val); 
                    getTermsWithLetter(val)
                }}
                setCurrentLetters={(val) => setCurrentLetters(val)}
                termNotSelected={termNotSelected}
                setTermNotSelected={(f) => setTermNotSelected(f)}

            />
            <div id='dictionary' className={classes.dictionary}>
                <div className={classes.dictionaryContainer}>      
                    <div
                        className={classes.dictionaryMobileStage}
                        {...(mobile ? { 'data-mobile-view': mobileMeaningStyle ? 'meaning' : 'terms' } : {})}
                    >
                    <div className={classes.termsContainer}>
                        <div className={classes.searchParams}>
                            <div className={classes.searchParamsInfo}>
                                {(() => {
                                    if (currentLetter !== "" && searched === '') {
                                    return (
                                        <h3 style={{margin: '0'}}>
                                            {/* {
                                                props.language === "de"
                                                ?
                                                <>Begriffe beginnend mit <span style={{fontStyle:'italic'}}>{currentSearch}</span></>
                                                :
                                                <>Terms starting with <span style={{fontStyle:'italic'}}>{currentSearch}</span></>
                                            } */}
                                            {pageContent.search_title_specific} <span style={{fontStyle:'italic'}}>{currentSearch}</span>
                                        </h3>
                                    )
                                    } else if (currentLetter === "" && searched === '') {
                                    return (
                                        <h3 style={{margin: '0'}}>
                                            {/* {
                                                props.language === "de"
                                                ?
                                                <>Alle Begriffe</>
                                                :
                                                <>All terms</>
                                            } */}
                                            {pageContent.search_title_all}
                                        </h3>
                                    )
                                    } else if (searched !== '') {
                                    return (
                                        <h3 style={{margin: '0'}}>
                                            {/* {
                                                props.language === "de"
                                                ?
                                                <>Begriffe beginnend mit <span style={{fontStyle:'italic'}}>{searched}</span></>
                                                :
                                                <>Terms starting with <span style={{fontStyle:'italic'}}>{searched}</span></>
                                            } */}
                                            {pageContent.search_title_specific} <span style={{fontStyle:'italic'}}>{searched}</span>
                                        </h3>
                                    )
                                    }
                                })()}
                                <div style={{color:'#A5A5A5', fontFamily:"'Roboto'"}}> <span className={classes.numberOfTerms}>
                                    {/* {
                                        props.language === "de"
                                        ?
                                        <>Anzahl der Begriffe:</>
                                        :
                                        <>Number of terms:</>
                                    } */}
                                    {pageContent.number_of_terms}
                                    </span>:  {terms.length}/{{...{...termsMeta}.pagination}.total}
                                </div>
                            </div>
                            <FilterByLetter currentLetters={currentLetters}/>
                        </div>
                        {
                            isLoadingTerms
                            ?
                            <>
                            <div className={classes.termSkeleton} >
                                <SkeletonTheme
                                    baseColor="#E1E2E1"
                                    highlightColor="#FDFDFD"
                                    borderRadius="10"
                                    duration={2}
                                >
                                    {[1,2,3,4,5].map(() => (
                                        <div className={classes.termBox}>
                                            <Skeleton width={100} />
                                            <div>
                                                <div><Skeleton highlightColor="#FDFDFD" width={100} /></div>
                                            </div>
                                            <div>
                                                <div><Skeleton highlightColor="#FDFDFD" width={100} /></div>
                                            </div>
                                            <div>
                                                <div><Skeleton highlightColor="#FDFDFD" width={100} /></div>
                                            </div>
                                        </div>
                                    ))}
                                </SkeletonTheme>
                            </div>
                            </>
                            :
                            <>
                            {/* {console.log(terms.length)} */}
                            <Terms 
                                pageContent={pageContent}
                                basicDictionary={true}
                                termNotSelected={termNotSelected}
                                setTermNotSelected={(f) => setTermNotSelected(f)}
                                currentSearch={currentSearch}
                                scroll={scrolledCount}
                                scrolledCount={(n) => {
                                    setScrolledCount((prevState) => { 
                                        // console.log(typeof(prevState) )
                                         if (prevState <= termsMeta.pagination.pageCount) {
                                            return n + prevState
                                        } else {
                                            return prevState
                                        }
                                    })
                                    
                                }}
                                expandCurrentSearch={(exp) => {
                                    
                                    setTerms((prevState) => {
                                        // console.log(prevState, "XD")
                                        // console.log(exp, ">__>")
                                        if (scrolledCount <= termsMeta.pagination.pageCount) {
                                            return ([
                                                ...prevState,
                                                ...exp
                                                ])
                                        } else {
                                            return prevState
                                        }
                                        
                                    })
                                }
                                    
                                }
                                reloaded={reloaded}
                                loaderLimit={scrolledCount}
                                loading={loader}
                                setLoader={(v) => setLoader(v)}
                                termsMeta={termsMeta}
                                termNotFound={terms.length === 0}
                                isLoading={isLoadingTerms}
                                terms={terms}
                                // meaningHasSynonym={meaningHasSynonym}
                                onClick2={(id) => {getMeaning(id); window.localStorage.setItem("termId", id);}} 
                                currentTerm = {meaning.text}
                                currentTermId = {termId}
                                clipboard = {clipboard}
                                toastVisible = {toastVisible}
                                setClipboard = {(cli) => 
                                    {   setClipboard(cli); 
                                        setToastProperties({
                                            description: `${clipboardTitle.toUpperCase()}`,
                                            borderColor: '#0A9DE4',
                                            icon: 'icon-success'
                                        })
                                    }
                                }
                                setToastVisible = {(val) => setToastVisible(val)}
                                setClipboardTitle = {(val) => setClipboardTitle(val)}
                                setLink = {(val) => {setLink([...[val], ...link]); localStorage.setItem('recentSearch',[...[val], ...link])}}
                                setShareId = {(val1, val2) => {handleShareButton(val1, val2)}}
                                setMobileMeaningStyle = {(val) => mobile ? setMobileMeaningStyle(val) : setMobileMeaningStyle(false)}
                                // setMobileMeaningStyle = {(val) => setMobileMeaningStyle(val)}
                                mobileMeaningStyle = {mobileMeaningStyle}
                                mobile = {mobile}
                                setSkeletonWidth = {(val) => setSkeletonWidth(val)}
                                searchLanguage = {searchLanguage}
                                sendConsultedTermMetric={(id) => sendConsultedTermMetric(id)}
                                newFilterSearch={newFilterSearch}
                            />
                            </>
                        }
                        
                    </div>
                    <div
                        className={classes.MeaningContainer}
                        style={mobile ? undefined : { display: mobileMeaningStyle === true || mobile === false ? 'block' : 'none' }}
                    >
                        {
                            isLoadingMeaning
                            ?
                            <>
                            <SkeletonTheme
                                baseColor="#E1E2E1"
                                highlightColor="#FDFDFD"
                                borderRadius="10"
                                duration={2}
                            >
                                <div className={classes.meaningSkeleton}>
                                    <div className={classes.meaningSkeletonTitle} style={{marginBottom: mobile?'30px':'50px'}}>
                                        <h3><Skeleton width={100} /></h3>
                                    </div>
                                    <div className={classes.meaningSkeletonText}>
                                        <div>
                                            <Skeleton  />
                                        </div>
                                        <div>
                                            <Skeleton  count={11} />
                                        </div>
                                    </div>
                                </div>
                            </SkeletonTheme>
                            </>
                            :
                            <Meaning 
                                pageContent={pageContent}
                                basicDictionary={true}
                                termNotSelected={termNotSelected}
                                meaning={meaning}
                                meaningHasSynonym={meaningHasSynonym}
                                id = {termId}
                                listOfCurrentTraductions = {listOfCurrentTraductions}
                                meaningTranslation = {meaningTranslation}
                                subtitleByLang={subtitleByLang}
                                baseTermId={baseTermId}
                                onClick4 = {(meaningTraductionId) => getMeaningTraducion(meaningTraductionId)}
                                searchLanguage = {searchLanguage}
                                isLoadingMeaningTranslation = {isLoadingMeaningTranslation}
                                setIsLoadingMeaningTranslation = {(val) => setIsLoadingMeaningTranslation(val)}
                                mobile = {mobile}
                                setMobileMeaningStyle = {(val) => setMobileMeaningStyle(val)}
                                mobileMeaningStyle = {mobileMeaningStyle}
                                setShareId = {(val1, val2) => {handleShareButton(val1, null)}}
                                skeletonWidth = {skeletonWidth}
                                setSkeletonWidth = {(val) => setSkeletonWidth(val)}
                            />
                           
                        }
                        
                    </div>
                    </div>
                </div>
            </div>
            <AppFooter language={props.language} />
        </div>
    );

}